import {
  ChevronDownIcon,
  InformationCircleIcon,
} from "@heroicons/react/16/solid";
import { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { QrCodeIcon } from "@heroicons/react/24/outline";

// const exchanges = [
//   { id: "binance", name: "Binance", status: "connected" },
//   { id: "okx", name: "OKX", status: "connect" },
//   { id: "gemini", name: "Gemini", status: "connected" },
//   { id: "bybit", name: "ByBIT", status: "connect" },
//   { id: "tokocrypto", name: "Toko Crypto", status: "connect" },
// ];

const DropdownExchange = ({
  id,
  label = "Exchange",
  placeholder = "Select Exchange",
  value,
  onChange,
  options,
  disabled,
  loading,

  isExplanation = false,
  explanation = "",
}) => {
  const [dataOptions, setDataOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState("bottom"); // bottom or top
  const boxRef = useRef(null);
  const dropdownRef = useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const tooltipRef = useRef(null);

  const handleSelect = (exchange) => {
    onChange(exchange);
    setIsOpen(false);
  };

  useEffect(() => {
    if (options?.length) {
      setDataOptions(options);
    } else {
      setDataOptions([]);
    }
  }, [options]);

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Check dropdown position on open
  useEffect(() => {
    if (isOpen && boxRef.current) {
      const boxRect = boxRef.current.getBoundingClientRect();
      const dropdownHeight = 250; // estimated dropdown height
      const spaceBelow = window.innerHeight - boxRect.bottom;
      const spaceAbove = boxRect.top;

      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setIsTooltipOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-full mt-5" ref={boxRef}>
      <div
        className="rounded-[10px] relative cursor-pointer"
        onClick={() => (!disabled ? setIsOpen((prev) => !prev) : {})}
      >
        <label className="flex items-center gap-1 text-xs text-gray-500 mb-1">
          {label}

          {isExplanation && explanation && (
            <span ref={tooltipRef} className="relative group">
              <InformationCircleIcon
                className="w-4 h-4 text-gray-400 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsTooltipOpen((prev) => !prev);
                }}
              />

              {/* Tooltip */}
              <span
                className={clsx(
                  "absolute z-20 w-fit max-w-[150px] p-2 text-xs text-white bg-black rounded-md shadow-lg top-6 left-1/2 -translate-x-1/2",
                  "hidden group-hover:block",
                  isTooltipOpen && "block"
                )}
              >
                {explanation}
                <span className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-black rotate-45" />
              </span>
            </span>
          )}
        </label>

        <div
          className={`w-full p-[12px] mt-[10px] rounded-[10px] text-sm border-none bg-[#F2F4F8] shadow-[0px_1.5px_1px_#C1C7CD] relative ${
            disabled && "!bg-[#C7C7C7] text-gray-400 cursor-default"
          }`}
        >
          <span
            className={`font-bold text-gray-900 capitalize ${
              disabled && "!text-gray-400"
            }`}
          >
            {value?.name || placeholder}
          </span>
          <ChevronDownIcon className="absolute w-[24px] h-[24px] right-4 top-[50%] translate-y-[-50%]" />
        </div>
      </div>
      {/* old style */}
      {/* <div
        className="border border-gray-300 rounded-[10px] p-4 relative cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <label className="block text-xs text-gray-500 mb-1">{label}</label>

        <div className="flex justify-between items-center cursor-pointer">
          <span className="text-base md:text-xl font-bold text-gray-900">
            {value?.name || placeholder}
          </span>
          <ChevronDownIcon className="absolute w-[24px] h-[24px] right-4 top-[50%] translate-y-[-50%]" />
        </div>
      </div> */}

      {isOpen && (
        <div
          ref={dropdownRef}
          className={clsx(
            "absolute w-full z-10 bg-white border border-gray-200 rounded-lg shadow-[0px_0px_10px_#0002] max-h-[250px] overflow-auto no-scrollbar",
            position === "top" ? "bottom-full mb-2" : "mt-2"
          )}
        >
          {loading ? (
            <span className="w-full text-center text-gray-400 block text-sm py-4">
              Loading get data...
            </span>
          ) : dataOptions?.length ? (
            dataOptions.map((ex) => (
              <div
                key={ex.id}
                className="flex items-center justify-between p-3 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(ex)}
              >
                <div className="flex items-center gap-1">
                  {/* <QrCodeIcon className="w-[20px] h-[20px]" /> */}
                  <span className="text-sm font-medium">{ex.name}</span>
                </div>
                {/* <span
                className={clsx(
                  "text-xs px-2 py-1 rounded-full w-[80px] text-center",
                  ex.status === "connected"
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 text-[#D9D9D9]"
                )}
              >
                {ex.status}
              </span> */}
              </div>
            ))
          ) : (
            <span className="w-full text-center text-gray-400 block text-sm py-4">
              No Data
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownExchange;
